export const ENV = {
  API_ROOT: "https://api.esocs.org.ng/api", //"https://localhost:7041/api","https://api.esocs.org.ng/api",
  APP_NAME: "ESOCS Data Bank"
};
